import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useOrganization } from "@clerk/clerk-react";
import { client, handleClientMethod } from "../client";

export const useDeleteCustomPart = () => {
  const { organization } = useOrganization();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (customPartId: string) => {
      return await handleClientMethod(
        client.DELETE("/api/custom-parts/{id}", {
          params: {
            path: {
              id: customPartId,
            },
          },
        }),
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["/api/custom-parts", organization?.id],
      });
    },
  });
};
